import Vue from 'vue';
import Vuex from 'Vuex';

import MenuModal from './menu-modal' 
import MaterialModal from './material-modal' 
import LoadingIcon from './loading-icon'

Vue.use(Vuex);

const state = {
}

const modules = {
  menu: MenuModal,
  material: MaterialModal,
  loading: LoadingIcon,
}


const mutations = {
 
}

const actions = {

}

const store = new Vuex.Store({
  state,
  modules,
  mutations,
  actions
})

export default store;
